import settingRoutes from './routes';
import organizationSlice from './store/organization.store';

export { settingRoutes };

const moduleConfig = {
  routes: settingRoutes,
  reducers: {
    organization: organizationSlice.reducer,
  },
};

export default moduleConfig;
